// @flow
import { compareAllDataEntries, compareNotesDates } from './comparators';
import type { DataEntry, LedgerAccount, JournalEntry } from './types';

const createLedgerAccountsMap = (ledgerAccounts: Array<LedgerAccount>) => {
  const ledgerAccountsMap = new Map();
  ledgerAccounts.forEach(ledgerAccount => ledgerAccountsMap.set(ledgerAccount.id, ledgerAccount));
  return ledgerAccountsMap;
};

const compileFollowUpViewData = (
  journalEntries: Array<JournalEntry>,
  ledgerAccounts: Array<LedgerAccount>,
): Array<DataEntry> => {
  const ledgerAccountsMap = createLedgerAccountsMap(ledgerAccounts);

  return journalEntries
    .reduce((dataEntriesWithOutstandingComments, journalEntry) => {
      journalEntry.dataEntries.forEach(dataEntry => {
        const ledgerAccount =
          dataEntry.ledgerAccount &&
          ledgerAccountsMap.has(dataEntry.ledgerAccount.id) &&
          ledgerAccountsMap.get(dataEntry.ledgerAccount.id);

        if (!ledgerAccount || ledgerAccount.role) {
          return dataEntriesWithOutstandingComments;
        }

        const clientComments = journalEntry?.clientComments
          ? [...journalEntry.clientComments].sort(compareNotesDates)
          : undefined;

        return dataEntriesWithOutstandingComments.push({
          id: dataEntry.id,
          amountInCents: dataEntry.amountInCents,
          ledgerAccount,
          journalEntry: {
            ...journalEntry,
            clientComments,
          },
        });
      });
      return dataEntriesWithOutstandingComments;
    }, [])
    .sort(compareAllDataEntries);
};

export default compileFollowUpViewData;
